var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-item-card"},[_vm._m(0),_c('div',{staticClass:"right-layout"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(`${_vm.value.title}【${_vm.format(_vm.value.publishTime)}】`))]),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.value.content))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-layout"},[_c('div',{staticClass:"circle"}),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }